const testimonialData = [
  {
    "name": "Fabrizio Fernandez",
    "handle": "@fab3304",
    "text": "The fusion of technology with traditional art forms has rekindled my love for experimental design.",
    "mention": "softations"
  },
  {
    "name": "Esme Rothschild",
    "handle": "@EsmeRothArt",
    "text": "The fusion of technology with traditional art forms has rekindled my love for experimental design. Their process is truly inspiring.",
    "mention": "softations"
  },
  {
    "name": "Darius Flynn",
    "handle": "@flynnn",
    "text": "The fusion of technology with traditional art forms has rekindled my love for experimental design.",
    "mention": "softations"
  },
  {
    "name": "Olivia Blackwood",
    "handle": "@olivia1992",
    "text": "The fusion of technology with traditional art forms has rekindled my love for experimental design. Thanks to the team for their dedication.",
    "mention": "softations"
  },
  {
    "name": "Liam Kinsley",
    "handle": "@liamk",
    "text": "An unparalleled experience! The blend of digital and classical methods is revolutionary.",
    "mention": "softations"
  },
  {
    "name": "Sophia Chen",
    "handle": "@schen_art",
    "text": "I've discovered new avenues for creativity I never thought possible with this approach.",
    "mention": "softations"
  },
  {
    "name": "Marcus Vane",
    "handle": "@marcusv",
    "text": "Absolutely brilliant work. It has fundamentally changed how I view contemporary art.",
    "mention": "softations"
  },
  {
    "name": "Amira Khan",
    "handle": "@amira_k",
    "text": "The details are stunning, and the commitment to quality is evident in every piece.",
    "mention": "softations"
  },
  {
    "name": "Javier Solis",
    "handle": "@solisj",
    "text": "Highly recommend! This team is pushing the boundaries of what is possible in digital design.",
    "mention": "softations"
  }
];

export default testimonialData;